import ApiErrorNotifier from "@components/authentication/ApiErrorNotifier";
import { SnackbarProvider } from "notistack";
import React from "react";
import ReactDOM from "react-dom/client";
import { SkeletonTheme } from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import "./index.css";
import store from "./redux/store";
import { AuthProvider } from "./router/AuthContext";
import AppRouter from "./router/Router";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <React.StrictMode>
    <AuthProvider>
      <Provider store={store}>
        <BrowserRouter>
          <div
            className="light hide-scrollbar"
            style={{
              background: "#FFFFFF",
            }}
          >
            <SnackbarProvider
              maxSnack={3}
              anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
            >
              <ApiErrorNotifier />
              <SkeletonTheme baseColor="#ECECEC" highlightColor="#F7F7F7">
                <AppRouter />
              </SkeletonTheme>
            </SnackbarProvider>
          </div>
        </BrowserRouter>
      </Provider>
    </AuthProvider>
  </React.StrictMode>
);
